import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { formatDate, getLatestEvents } from "@/lib/events";

export default function FeaturedEvents() {
  const [lead, ...rest] = getLatestEvents(4);

  if (!lead) {
    return null;
  }

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="本期重点"
          title="正在被讨论的网红事件"
          desc="挑选热度最高、信息量最大的事件做完整复盘，标出每个关键节点，把争议拆开讲清楚。"
          extra={
            <Link
              to="/events"
              className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              浏览事件库
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />

        <div className="mt-9 grid gap-6 lg:grid-cols-12">
          <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-7">
            <Link to={`/events/${lead.slug}`} className="flex h-full flex-col">
              <div className="relative h-56 w-full overflow-hidden bg-background-200 md:h-72">
                <img
                  src={lead.cover}
                  alt={`${lead.title} 复盘封面图`}
                  title={`${lead.title} - 网红事件完整经过`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                />
                <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
                  重点复盘
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6 md:p-7">
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 font-medium text-secondary-900">
                    {lead.categoryName}
                  </span>
                  <span>{formatDate(lead.publishedAt)}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line"></i>
                    {lead.heat}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-2xl">
                  {lead.title}
                </h3>
                <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-[15px]">
                  {lead.summary}
                </p>
                <span className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                  阅读完整复盘
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </div>
            </Link>
          </article>

          <div className="grid gap-6 sm:grid-cols-3 lg:col-span-5 lg:grid-cols-1">
            {rest.map((event) => (
              <article
                key={event.slug}
                className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
              >
                <Link to={`/events/${event.slug}`} className="flex w-full gap-4">
                  <div className="h-20 w-20 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-24 md:w-24">
                    <img
                      src={event.cover}
                      alt={`${event.title} 复盘封面图`}
                      title={`${event.title} - 网红事件深度解析`}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex min-w-0 flex-1 flex-col">
                    <span className="text-xs text-secondary-700">{event.categoryName}</span>
                    <h3 className="mt-1.5 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
                      {event.title}
                    </h3>
                    <span className="mt-auto flex items-center gap-3 pt-2 text-xs text-foreground-500">
                      <span>{formatDate(event.publishedAt)}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-fire-line"></i>
                        {event.heat}
                      </span>
                    </span>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}